import { useMemo } from 'react';
import { matchPath } from 'react-router';

import { catchAll } from '@sorare/routing';

import { Rarity, Sport } from '#src/__generated__/globalTypes.ts';
import { API_ROOT } from '#src/config.ts';

import {
  ACTIVITY,
  ANY_SPORT_MARKET,
  ANY_SPORT_PLAY_EVENTTYPE,
  ANY_SPORT_PLAY_EVENTTYPE_FIXTURE,
  ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_COMPETITION_COMPETITION,
  ANY_SPORT_SCORES_MATCHES_DAY_GAMEID,
  BLOG_SPORT,
  CAREERS,
  CONFIRM_DEVICE,
  CONFIRM_EMAIL,
  COOKIE_POLICY,
  DEBUG_DEVICE,
  FOOTBALL,
  GAME_RULES,
  HELP,
  INVITE,
  LANDING,
  LICENSED_PARTNERS,
  MLB,
  MOBILE_SIGN_UP,
  MY_SORARE,
  NBA,
  OAUTH_AUTHORIZE,
  PRESS,
  PRIVACY_POLICY,
  R_USERSLUG,
  SETTINGS,
  TERMS_AND_CONDITIONS,
} from './__generated__/routes.ts';

export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_MATCH_CENTER = `${ANY_SPORT_PLAY_EVENTTYPE_FIXTURE}/match-center`;
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_COMPETITION_COMPETITION_REWARDS = `${ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_COMPETITION_COMPETITION}/rewards`;
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_USERGROUP_USER = `${ANY_SPORT_PLAY_EVENTTYPE_FIXTURE}/:userGroup/:user`;
export const ANY_SPORT_PLAY_EVENTTYPE_MY_LINEUPS_LINEUP = `${ANY_SPORT_PLAY_EVENTTYPE}/my-lineups/:lineup`;
export const ANY_SPORT_SCORES_MATCHES_DAY_GAMEID_BOX_SCORE = `${ANY_SPORT_SCORES_MATCHES_DAY_GAMEID}/box-score`;
export const ANY_SPORT_SCORES_MATCHES_DAY_GAMEID_STATS = `${ANY_SPORT_SCORES_MATCHES_DAY_GAMEID}/stats`;

const SHARED_PAGES = [
  LANDING,
  MLB,
  catchAll(SETTINGS),
  catchAll(MY_SORARE),
  CAREERS,
  PRESS,
  TERMS_AND_CONDITIONS,
  LICENSED_PARTNERS,
  GAME_RULES,
  PRIVACY_POLICY,
  COOKIE_POLICY,
  CONFIRM_EMAIL,
  CONFIRM_DEVICE,
  DEBUG_DEVICE,
  catchAll(INVITE),
  R_USERSLUG,
  MOBILE_SIGN_UP,
  OAUTH_AUTHORIZE,
  catchAll(ACTIVITY),
  catchAll(BLOG_SPORT),
  catchAll(HELP),
];

export function sharedAcrossSportsPage(pathname: string) {
  return !!SHARED_PAGES.find(page => matchPath(page, pathname));
}

export function isMlbPage(pathname: string) {
  return !!matchPath(catchAll(MLB), pathname);
}

export function isNBAPage(pathname: string) {
  return !!matchPath(catchAll(NBA), pathname);
}

// this should stay a hook for future feature flags integration
export const useDefaultSportPages = (
  getLoggedInVariant?: boolean
): { [key in Sport]: string } => {
  return useMemo(
    () => ({
      [Sport.NBA]: NBA,
      [Sport.FOOTBALL]: FOOTBALL,
      [Sport.BASEBALL]: getLoggedInVariant ? `${MLB}/play` : MLB,
    }),
    [getLoggedInVariant]
  );
};

export const RAMP_TRANSACTION_WEBHOOK = `${API_ROOT}/webhooks/ramp/transaction_state_updated`;

export const ANY_SPORT_MARKET_COMMON_PACKS =
  `${ANY_SPORT_MARKET}?rarity=${Rarity.common}` as const;
